import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link } from "react-scroll";
import classnames from 'classnames';
import ContactDetailsView from './ContactDetailsView';
import BusinessDetailsView from './BusinessDetailsView';
import TaxationStatutoryView from './TaxationStatutoryView';
import BankDetailsView from './BankDetailsView';
import ExceptionalFlowDocuments from './ExceptionalFlowDocuments';
import axiosHelper from '../../../../../../../axiosHelper';
import { API } from '../../../../../../../config/constants';

const KysOneView = (props) => {
  const [activeTab, setActiveTab] = useState('1');
  const [supplierDetail, setSupplierDetail] = useState(null)
  const [exceptionFlowDocumentList, setExceptionFlowDocumentList] = useState([])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("VendorRequirementRegistrationId");
    if (id) {
      getExceptionFlowDocumentList(id)
      GetKYS1DetailByVendorRRId(id)
    }
  }, []);

  const GetKYS1DetailByVendorRRId = (id) => {
    axiosHelper.get(`${API.GetKYS1DetailByVendorRRId}?VendorRequirementRegistrationId=${id}`)
      .then(async (res) => {
        if (res?.data?.IsSuccessful) {
          setSupplierDetail(res?.data);
        }
      })
      .catch((error) => {

      });
  }

  const getExceptionFlowDocumentList = (id) => {
    axiosHelper.get(`${API.getExceptionFlowDocumentList}?VendorRequirementRegistrationId=${id}`)
      .then(async (res) => {
        if (res?.data?.IsSuccessful) {
          // setExceptionFlowDocumentList([5,6])
          setExceptionFlowDocumentList(res?.data?.Data);
        }
        // props.setVendorKys1Data(res?.data)
      })
      .catch((error) => {

      });
  }

  const toggleKys1FormTabs = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }


  return (
    <div className="time-line-download-wrap hl-assessment-accordian hl-self-assessment-wrap">
      <Row>
        <Col lg='12'>
          <h3 className='mt-2 mb-2'>Registration Form View
            {(props?.supplierFormDetailData?.ApplicationNo || props?.supplierFormDetailData?.VendorRegistrationStatusName) && (
              <small className='pl-2 hl-status-update'>
                (
                {props?.supplierFormDetailData?.ApplicationNo && (
                  <span><strong>Application No.:</strong> {props?.supplierFormDetailData?.ApplicationNo}</span>
                )},
                {props?.supplierFormDetailData?.VendorRegistrationStatusName && (
                  <span className='pl-4'><strong>Registration Status:</strong> {props?.supplierFormDetailData?.VendorRegistrationStatusName}</span>
                )}
                )
              </small>
            )}
          </h3>
          <label>(The information populated is this form is taken from your submitted application.)</label>
          <h3 className='my-3 fw-normal'>
            <small className='hl-status-update'><strong>Supplying to which plants of Havells:</strong> {supplierDetail?.Data?.BankDetails?.GeneralDetailsOfVendor?.SupplyingPlantName || "N/A"}</small>
          </h3>
          {supplierDetail?.Data?.ReviewRemark &&
  <h3 className='my-3 fw-normal' style={{backgroundColor: "lightblue", padding: "5px"}}>
    <small className='hl-status-update'><strong>Review Remark:</strong> {supplierDetail?.Data?.ReviewRemark || "N/A"}</small>
  </h3>
}
          <div className="hl-assessment-tab-section mt-4">
            <Nav tabs className="subtabs mt-0 p-relative">
              <NavItem>
                <NavLink id={`dashboard_Masters_Pending_Approval`} className={classnames({ active: activeTab === '1' })}
                  onClick={() => { toggleKys1FormTabs('1'); }}
                >
                  Contact Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink id={`dashboard_Masters_Awaiting_Approval`} className={classnames({ active: activeTab === '2' })}
                  onClick={() => { toggleKys1FormTabs('2'); }}
                >
                  Business Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink id={`dashboard_Masters_Awaiting_Approval`} className={classnames({ active: activeTab === '3' })}
                  onClick={() => { toggleKys1FormTabs('3'); }}
                >
                  Taxation Statutory
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink id={`dashboard_Masters_Awaiting_Approval`} className={classnames({ active: activeTab === '4' })}
                  onClick={() => { toggleKys1FormTabs('4'); }}
                >
                  Bank Details
                </NavLink>
              </NavItem>
              {
                exceptionFlowDocumentList?.length > 0 && (
                  <NavItem>
                    <NavLink id={`dashboard_Masters_Awaiting_Approval`} className={classnames({ active: activeTab === '5' })}
                      onClick={() => { toggleKys1FormTabs('5'); }}
                    >
                      Exceptional Flow Documents
                    </NavLink>
                  </NavItem>
                )
              }
            </Nav>
            <TabContent activeTab={activeTab} className="hl-tab-content-section h-100">
              {activeTab === '1' &&
                <TabPane tabId="1" className="pt-4">
                  <ContactDetailsView
                    supplierDetail={supplierDetail}
                    toggleKys1FormTabs={toggleKys1FormTabs} />
                </TabPane>}

              {activeTab === '2' &&
                <TabPane tabId="2" className="pt-4">
                  <BusinessDetailsView
                    supplierDetail={supplierDetail}
                    toggleKys1FormTabs={toggleKys1FormTabs} />
                </TabPane>}

              {activeTab === '3' &&
                <TabPane tabId="3" className="pt-4">
                  <TaxationStatutoryView
                    supplierDetail={supplierDetail}
                    toggleKys1FormTabs={toggleKys1FormTabs} />
                </TabPane>}

              {activeTab === '4' &&
                <TabPane tabId="4" className="pt-4">
                  <BankDetailsView
                    viewDataFromSupplier={props?.viewDataFromSupplier}
                    supplierDetail={supplierDetail}
                    toggleKys1FormTabs={toggleKys1FormTabs} />
                </TabPane>}
              {/*  */}
              {activeTab === '5' &&
                <TabPane tabId="5" className="pt-4">
                  <ExceptionalFlowDocuments
                    supplierDetail={supplierDetail}
                    toggleKys1FormTabs={toggleKys1FormTabs}
                    exceptionFlowDocumentList={exceptionFlowDocumentList}
                    getExceptionFlowDocumentList={getExceptionFlowDocumentList}
                  />
                </TabPane>}
            </TabContent>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default KysOneView;
